module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB1SURBVCiRlZKxEcQgDAQXVUIrVEJMF+5CQ/iVuBUqufnEiXlk/Aqlu5VuRqn3fgBVUmmtDV6Uu2czO4GPARXIZna6e/7DnIFqkgow3kAm85BUUjSY40SatBPsZmm3BeDpuhtgBbnaYbQfwAJCZA4BE4SnH/kCOglscw3zjpMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-date-picker2/src/images/arrow-up.png
// module id = lmgQ
// module chunks = 6